<ng-container *ngIf="oneLine">
  <span *ngIf="address" class="address">
    {{ addressOneline }}
  </span>
</ng-container>
<ng-container *ngIf="!oneLine">
  <div *ngIf="address" class="address">
    <p class="address-line1" *ngIf="addressLine1">
      {{ addressLine1 }}
    </p>
    <p class="address-line2" *ngIf="addressLine2">
      {{ addressLine2 }}
    </p>
    <p class="address-line3" *ngIf="addressLine3">
      {{ addressLine3 }}
    </p>
    <ng-container
      *ngIf="county && showCounty; then withCounty; else withoutCounty"
    ></ng-container>
    <ng-template #withCounty>
      <p *ngIf="city || county">
        {{ city }}{{ city && county ? ',' : '' }}
        {{ county }}
      </p>
      <p *ngIf="stateCode || postalCode">
        {{ stateCode }}
        {{ postalCode }}
      </p>
    </ng-template>
    <ng-template #withoutCounty>
      <p *ngIf="city || stateCode || postalCode">
        {{ city }}{{ city && (stateCode || postalCode) ? ',' : '' }}
        {{ stateCode }}
        {{ postalCode }}
      </p>
    </ng-template>
    <p *ngIf="country">
      {{ country }}
    </p>
  </div>
</ng-container>
